import {
  GET_ACCOUNT_ADDRESSES,
  ADD_ACCOUNT_ADDRESS,
  UPDATE_ACCOUNT_ADDRESS,
  REMOVE_ACCOUNT_ADDRESS,
} from '../actions/accountAddress.actions';

const initialState = [];

export default function accountAddress(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ACCOUNT_ADDRESSES:
      return action.payload;

    case ADD_ACCOUNT_ADDRESS:
      return [...state, action.payload];

    case UPDATE_ACCOUNT_ADDRESS: {
      const idx = state.findIndex((o) => o.id === action.payload.id);
      if (idx === -1) return state;
      const newState = [...state];
      newState[idx] = action.payload;
      return newState;
    }

    case REMOVE_ACCOUNT_ADDRESS:
      return state.filter((o) => o.id !== action.payload.id);

    default:
      return state;
  }
}
